/* @flow */
/* eslint-env es6,browser */

/**
 * @class
 * @description Browser Utility from EOW
 * @exports utils/BrowserUtil
 */
class _BrowserUtil {
  _ua: string;
  _config: Array<browserConfig>;
  _cache: browserConfig;

  constructor(ua?: string = navigator.userAgent) {
    this._ua = ua.toLowerCase();
    this._config = [
      {
        search: 'edge',
        name: 'Edge',
        sname: 'edge',
        versionPrefix: 'edge',
        version: ''
      },
      {
        search: 'opera',
        name: 'Opera',
        sname: 'opera',
        versionPrefix: 'opera',
        version: ''
      },
      {
        search: 'chrome',
        name: 'Chrome',
        sname: 'chrome',
        versionPrefix: 'chrome',
        version: ''
      },
      {
        search: 'firefox',
        name: 'Firefox',
        sname: 'ff',
        versionPrefix: 'firefox',
        version: ''
      },
      {
        search: 'safari',
        name: 'Safari',
        sname: 'safari',
        versionPrefix: 'version',
        version: ''
      },
      {
        search: 'msie',
        name: 'Internet Explorer',
        sname: 'ie',
        versionPrefix: 'msie',
        version: ''
      },
      {
        search: 'trident',
        name: 'Internet Explorer',
        sname: 'ie',
        versionPrefix: 'rv',
        version: ''
      }
    ];
    this._cache = this._getInfo();
  }

  _getInfo(): browserConfig {
    let info = this._getName();
    info.version = this._getVersion(info);
    return info;
  }

  _getName(): browserConfig {
    //set default value
    let defRet = {
      search: 'unknown',
      name: 'Unknown',
      sname: 'others',
      versionPrefix: '',
      version: ''
    };
    let index = this._config.findIndex(
      obj => this._ua.indexOf(obj.search) !== -1
    );
    return index !== -1 ? this._config[index] : defRet;
  }

  _getVersion(info: browserConfig): string {
    let offset =
      this._ua.indexOf(info.versionPrefix) + info.versionPrefix.length + 1; //+1 is for '/' or space or ':' after prefix
    let ret = '',
      ch = '';
    while (
      (ch = this._ua.charAt(offset)) &&
      ch !== ' ' &&
      (!isNaN(ch) || ch === '.')
    ) {
      ret += ch;
      offset++;
    }
    return ret
      .split('.')
      .splice(0, 2)
      .join('.');
  }

  /**
   * @description This function is used to get the name of the user's browser
   * @return {string} - [Chrome, Safari, Internet Explorer, Opera, Firefox] or Unknown
   */
  getName(): string {
    return this._cache.name;
  }

  /**
   * @description short name of the browser
   * @return {string} - [ff, chrome, safari, ie, opera]
   */
  getShortName(): string {
    return this._cache.sname;
  }

  /**
   * @description get browser version
   * @return {string} - browser version
   */
  getVersion(): string {
    return this._cache.version;
  }

  /**
   * @description get browser major version
   * @return {number} - Version Number
   */
  getMajorVersion(): number {
    return parseInt(this._cache.version, 10);
  }

  /**
   * @description check browser version is ie 10 and below
   * @returns {boolean} - IE<9 or not
   */
  isOldIE() {
    return this.getShortName() === 'ie' && this.getMajorVersion() <= 10;
  }
}

//export singleton object as default for this module
let BrowserUtil = new _BrowserUtil();
export { _BrowserUtil, BrowserUtil };
